/**
 * クリニックIDの定数
 *
 * @remarks D-make clinicは今後も開発環境での表示確認で使用するため、コメントアウトしている
 */
export const CLINIC_IDS = {
  // D-make clinic（開発環境表示用）
  // D_MAKE_CLINIC: 39,
  // くぼた鶴間院（本番）
  KUBOTA_TSURUMA: 43,
  // くぼた鶴間院（テスト）
  KUBOTA_TSURUMA_TEST: 83,
  // くぼた相模大野院（本番）
  KUBOTA_SAGAMIONO: 84,
  // くぼた相模大野院（テスト）
  KUBOTA_SAGAMIONO_TEST: 85,
  // くぼた東林間院（本番）
  KUBOTA_HIGASHIRINKAN: 86,
  // くぼた東林間院（テスト）
  KUBOTA_HIGASHIRINKAN_TEST: 87,
} as const;

/**
 * 特定メッセージを表示すべきクリニックIDの配列
 *
 * @remarks 新しいクリニックをメッセージ表示対象に追加する場合は、この配列に追加するだけでよい
 */
export const SHOW_BOOKING_MESSAGE_CLINICS = [
  // CLINIC_IDS.D_MAKE_CLINIC,
  CLINIC_IDS.KUBOTA_TSURUMA,
  CLINIC_IDS.KUBOTA_TSURUMA_TEST,
  CLINIC_IDS.KUBOTA_SAGAMIONO,
  CLINIC_IDS.KUBOTA_SAGAMIONO_TEST,
  CLINIC_IDS.KUBOTA_HIGASHIRINKAN,
  CLINIC_IDS.KUBOTA_HIGASHIRINKAN_TEST,
];
